import { zendeskApis } from '@apis/dashboard/zendeskApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useZendeskD2dTickets = createUseQuery(
  (d2dNo: string) => [`/zendesk/${d2dNo}/tickets/`],
  (d2dNo) => () =>
    zendeskApis
      .get('/dashboard/zendesk/{d2dNo}/tickets/', {
        path: { d2dNo },
      })
      .then((r) => r[200] ?? []),
);
